<template>
  <div class="eventComp_mode_15 eventComp_mode_container" v-show="currThemeObj">
    <div class="tableScrollArea" ref="tableParentDom">
      <el-tabs
        v-model="tabActiveKey"
        type="card"
        @tab-click="handleClickTab"
        v-if="groupTable && groupTable.length > 0"
      >
        <el-tab-pane
          :label="group.tabName"
          :name="group.tabKey"
          v-for="group in groupTable"
          :key="group.tabKey"
        >
          <multiLevelFold_table
            :currThemeObj="currThemeObj"
            :currCid="currCid"
            :currSid="currSid"
            :tableMode="tableMode"
            :parentWidthPx="parentWidthPx"
            :isScrollFlag="isScrollFlag"
            :variableColWidthVw="variableColWidthVw"
            :tableCellDefaultWidthVw="tableCellDefaultWidthVw"
            :defaultWidthVwNum="group.defaultWidthVwNum"
            :tableColumnData="group.tableColumnData"
            :tableData="group.tableData"
            :expandKey="expandKey"
            :isExpandAll="isExpandAll"
            :competitorType="competitorType"
            @toParentEvent="toParentEventHandler"
            v-show="group.tableData && group.tableData.length > 0"
          ></multiLevelFold_table>
        </el-tab-pane>
      </el-tabs>
    </div>
    <div class="note_box" v-show="annotationList && annotationList.length > 0">
      <span class="note_title" v-text="'注释'"></span>
      <span class="note_info">
        <span
          class="noteInfo_item"
          v-for="(item, index) in annotationList"
          :key="index"
          v-text="`${item.name}：${item.explain}`"
        ></span>
      </span>
    </div>
  </div>
</template>

<script>
// 适用： 表格上面带tab切换的 + 带展开行  （大运会暂时没有用到这个组件）
import multiLevelFold_table from '@components/platfromBase/compreSportsMeet/table/multiLevelFold_table.vue'
import cup_base_data_mixin from '@mixins/cup_base_data'
export default {
  name: 'eventComp_mode_15',
  components: {
    multiLevelFold_table,
  },
  props: {
    currSportsDetail: {
      type: Object,
      default: () => ({}),
    },
    sportsTypeArr: {
      type: Array,
      default: () => {
        return []
      },
    },
    datas: {
      type: Object,
      default: () => ({}),
    },
    tabType: {
      type: String, //确定数据来自于 出场名单'startList'  ||【 本场数据'localData' || 轮次成绩'roundResult' ||  单项成绩'singleResult' || 团体成绩 'teamResult' || 全能成绩'combinedResult'】,
      default: '',
    },
    competitorType: {
      type: String,
      default: '', // A || D || T
    },
    groupIndexStr: {
      type: String,
      default: '', // ['-1':没有分组, '-2':有分组且总的比赛进入赛果, '0':有分组且第一个分组比赛进入赛果]；有分组的比赛进入赛果传的都是总的比赛ID
    },
  },
  mixins: [cup_base_data_mixin],
  watch: {
    datas: {
      handler(newVal, oldVal) {
        console.debug('mode_15 刷新数据:', newVal, oldVal)
        if (JSON.stringify(newVal) != JSON.stringify(oldVal)) {
          this.init()
        }
      },
      //   immediate: true,
      deep: true,
    },
  },
  data() {
    return {
      isScrollBottom: false,
      tableMode: 'eventComp_mode_15',
      parentWidthPx: 0,
      parentHeightPx: 0,
      isScrollFlag: false,
      isClickFlag: false,
      variableColWidthVw: null,
      tableCellDefaultWidthVw: 5.55, //默认列的宽度决定了展开行箭头占得宽度，因此这个最好不要动；如果需要处理某个单独列的宽度时，单独赋值
      expandCellDefaultWidthVw: 5.55,
      defaultWidthVwNum: null,
      annotationList: [],
      groupTable: [],
      tableColumnData: [],
      tableData: null,
      expandKey: 'isExpand',
      isExpandAll: false, //只要需要expand属性默认都是展开，这个只是控制显示的高度
      tabActiveKey: '',
      currModeObj: null,
      renderModeList: [
        {
          modeNameArr: [],
          tableCellDefaultWidthVw: 6.94,
          sportsIdArr: ['GRY'],
          resultKeyArr: ['result_unit', 'result_unit'],
          isCompetitorTypeArr: ['A', 'T'],
        },
        {
          modeNameArr: [],
          defaultInsertCustomColuIndex: 0, //在第0个后插入
          tableCellDefaultWidthVw: 6.94,
          variableColWidthVw: [],
          sportsIdArr: ['FRS', 'SWM', 'SMT'],
          resultKeyArr: [
            'result_apparatus',
            'result_apparatus',
            'result_apparatus',
            'startList',
          ],
          isCompetitorTypeArr: ['A-GP', 'A', 'T', 'T-GP'], //游泳 A|T；
          // tabTypeArr: ['singleResult', 'groupResult', 'startList'], // 游泳 分组预赛|半决赛：【小组成绩】
        },
        {
          modeNameArr: [],
          defaultInsertCustomColuIndex: 0, //在第0个后插入
          tableCellDefaultWidthVw: 6.94,
          variableColWidthVw: [],
          sportsIdArr: ['ROW', 'RCB'],
          resultKeyArr: [
            'result_apparatus',
            'result_apparatus',
            'result_apparatus',
            'startList',
            'startList',
          ],
          isCompetitorTypeArr: ['A', 'D', 'T', 'D-GP', 'T-GP'], //赛艇 数据tab有区分俩个路径 A|D|T，但出场名单只有一个路径，如果同一个mode里面需要区分没有分组和分组只能通过T和T-GP模式判断；因只要是[x]-GP就是出场名单
          // tabTypeArr: ['singleResult', 'singleResult', 'singleResult'], // 赛艇 分组预赛|半决赛：【小组成绩】
        },
        {
          modeNameArr: [],
          defaultInsertCustomColuIndex: 0, //在第0个后插入
          tableCellDefaultWidthVw: 6.94,
          variableColWidthVw: [],
          sportsIdArr: ['SMT', 'ATH'],
          resultKeyArr: ['startList', 'startList'],
          isCompetitorTypeArr: ['T', 'T-GP'], //田径团体 T | 分组出场名单；
          // tabTypeArr: ['groupResult'], // 田径团体 部分赛段需要
        },
        {
          modeNameArr: [],
          defaultInsertCustomColuIndex: 0, //在第0个后插入
          tableCellDefaultWidthVw: 6.94,
          variableColWidthVw: [],
          sportsIdArr: ['SBD'],
          resultKeyArr: ['startList', 'result_apparatus'],
          isCompetitorTypeArr: ['T-GP', 'T'], //单板滑雪 T | 分组出场名单；
          // tabTypeArr: ['groupResult'], // 单板滑雪 部分赛段需要
        },
        {
          modeNameArr: [],
          defaultInsertCustomColuIndex: 0, //在第0个后插入
          tableCellDefaultWidthVw: 6.94,
          variableColWidthVw: [],
          sportsIdArr: ['STK', 'SSK'],
          resultKeyArr: ['result_apparatus', 'result_apparatus', 'startList'],
          isCompetitorTypeArr: ['A', 'T', 'A-GP'], //单板滑雪 T | 分组出场名单；
          // tabTypeArr: ['groupResult'], // 单板滑雪 部分赛段需要
        },
      ],
    }
  },
  mounted() {
    window.addEventListener('resize', () => {
      this.onResizeEvent()
    })
    this.init()
  },
  beforeDestroy() {
    window.removeEventListener('resize', () => {
      this.onResizeEvent()
    })
  },
  methods: {
    async init() {
      this.$nextTick(() => {
        this.onResizeEvent()
        if (this.currSportsDetail && this.currSportsDetail.sportsId) {
          this.renderModeList.forEach((modeItem) => {
            if (
              modeItem.sportsIdArr.includes(this.currSportsDetail.sportsId) &&
              modeItem.isCompetitorTypeArr.includes(this.competitorType)
            ) {
              this.currModeObj = modeItem
            }
          })
        }
        console.debug(
          'mode_15 this.currModeObj',
          this.datas,
          this.currModeObj,
          this.currSportsDetail.sportsId,
          this.competitorType
        )
        if (this.currModeObj) {
          let i = this.currModeObj.isCompetitorTypeArr.indexOf(
            this.competitorType
          )
          const formatData = JSON.parse(
            JSON.stringify(
              this.currModeObj.resultKeyArr[i] === 'startList'
                ? this.datas
                : this.datas[this.currModeObj.resultKeyArr[i]]
            )
          )
          if (formatData.annotation) {
            this.annotationList = formatData.annotation
          }
          this.computedModeData(formatData)
        }
      })
    },
    handleClickTab(tab, event) {
      console.debug(tab, event)
    },
    toParentEventHandler(data) {
      console.debug(data)
      if (data && data.eventName === 'isTableAllExpandEvent') {
        this.groupTable.forEach((groupTable) => {
          groupTable.tableData.forEach((rowData) => {
            rowData.isShowChild = data.data
          })
        })
        this.isExpandAll = data.data
      }
      if (data && data.eventName === 'clickItemRowArrowEvent') {
        let isExpandAll = true
        // 有一个是关闭的，全部就是【关闭】状态
        console.debug('this.tableData:', this.tableData)
        this.groupTable.forEach((groupTable) => {
          if (groupTable.key === this.tabActiveKey) {
            groupTable.tableData.forEach((rowData) => {
              if (!rowData.isShowChild) {
                isExpandAll = false
              }
            })
          }
        })
        this.isExpandAll = isExpandAll
      }
    },
    onResizeEvent() {
      if (this.$refs.tableParentDom) {
        this.parentWidthPx = this.$refs.tableParentDom.offsetWidth
      } else {
        console.debug('dom 不存在')
      }
    },
    computedModeData(data) {
      console.debug('mode_15 computedModeData:', data)
      //   this.groupTable = []
      if (data && data.result_data && data.result_data.length > 0) {
        this.groupTable = data.result_data.map((group) => {
          if (!group.group_code) {
            group.group_code = group.group_name || null
          }
          if (group.group_name) {
            let tableTotal = group.detail_list ? group.detail_list.length : 0
            const table_headArr = group.table_head
            let defaultWidthVwNum = 0
            let tableColumnData = []

            // 表头
            const headColumns = []
            let deletColumnNum = 0
            table_headArr.forEach((colums, colIndex) => {
              if (colums && colums.map_key_arr.length < 2) {
                headColumns.push({
                  colKey: colums.map_key_arr[0] ? colums.map_key_arr[0] : '',
                  colTitle: colums.name ? colums.name : '',
                })
              }
            })

            deletColumnNum = 2
            headColumns.push({
              colKey: 'arrowIcon',
              colTitle: '',
            })
            headColumns.push({
              colKey: 'isExpand',
              colTitle: '',
            })

            let customColumn = {}
            if (this.currModeObj.tableCellDefaultWidthVw) {
              this.tableCellDefaultWidthVw =
                this.currModeObj.tableCellDefaultWidthVw
            }
            let widthVw = this.tableCellDefaultWidthVw

            let rowHeightVw = 2.778, //第一行 行高 (只有奖牌榜medalTally用到这个字段，其他视图展开行的打开隐藏不需要计算这个值，它们的高度都是用内容撑出的高度)
              childRowHeightVw = 6.94, //第一行的展开行，如果是表格的话，就是展示数据的那一行的行高（一般这个行数是不固定的）
              childRowHeightOtherVw = 0 //0.694是表格最下面的留白

            let childRowBaseHeightVw = 0 //第一行展开行的基础高度（固定的高度）
            if (['A', 'A-GP'].includes(this.competitorType)) {
              // 体操 单人

              const otherColumns = headColumns
              if (tableColumnData.length == 0) {
                deletColumnNum++
                customColumn = {
                  prop: 'playerName-playerLogo-playerGender-teamLogo-teamName', //fristColumnPropArr.join('-'),
                  label: '运动员',
                  // widthVw:
                  //   this.currModeObj.variableColWidthVw[
                  //     this.currModeObj.sportsIdArr.indexOf(
                  //       this.currSportsDetail.sportsId
                  //     )
                  //   ], //对应列的宽度，单位vw
                  className: 'columnPlayerGroupClass', //单独定制的头部样式class
                  // fixed: 'left', //是否锁定，如果开启不滚动，此字段无效
                }

                for (let i = 0; i < otherColumns.length; i++) {
                  const item = otherColumns[i]
                  tableColumnData.push({
                    prop: item.colKey,
                    label: item.colTitle,
                    widthVw: ['arrowIcon', 'isExpand'].includes(item.colKey)
                      ? this.tableCellDefaultWidthVw / 2
                      : widthVw, //单独设置 [arrowIcon, isExpand] 的对应列的宽度，单位vw, 宽度为普通的一半
                    className: ['arrowIcon', 'isExpand'].includes(item.colKey)
                      ? 'expandTdClassName'
                      : '', //单独定制的头部样式class
                    selected: '',
                  })
                  if (i == 0) {
                    tableColumnData.push(customColumn)
                  }
                }
                defaultWidthVwNum = tableColumnData.length - deletColumnNum //减去这3列[playerName-playerLogo-playerGender-teamLogo-teamName, arrowIcon, isExpand]
                console.debug('tableColumnData:', tableColumnData)
              }
            } else if (
              ['T', 'T-GP'].includes(this.competitorType) ||
              (this.currModeObj.isCompetitorTypeArr.includes(
                this.competitorType
              ) &&
                ['D', 'D-GP'].includes(this.competitorType) &&
                ['ROW', 'RCB'].includes(this.currSportsDetail.sportsId))
            ) {
              // 团体 ||  单独处理ROW赛艇D和D-GP的赛果成绩也走这里

              const otherColumns = headColumns
              if (tableColumnData.length == 0) {
                deletColumnNum++
                customColumn = {
                  prop: 'teamLogo-teamName', //fristColumnPropArr.join('-'),
                  label: '国家/地区',
                  // widthVw: this.variableColWidthVw, //对应列的宽度，单位vw
                  className: 'columnTeamLogoTeamNameClass', //单独定制的头部样式class
                  // fixed: 'left', //是否锁定，如果开启不滚动，此字段无效
                }

                for (let i = 0; i < otherColumns.length; i++) {
                  const item = otherColumns[i]
                  tableColumnData.push({
                    prop: item.colKey,
                    label: item.colTitle,
                    widthVw: ['arrowIcon', 'isExpand'].includes(item.colKey)
                      ? this.tableCellDefaultWidthVw / 2
                      : widthVw, //单独设置 [arrowIcon, isExpand] 的对应列的宽度，单位vw, 宽度为普通的一半
                    className: ['arrowIcon', 'isExpand'].includes(item.colKey)
                      ? 'expandTdClassName'
                      : '', //单独定制的头部样式class
                    selected: '',
                  })
                  if (i == 0) {
                    tableColumnData.push(customColumn)
                  }
                }
                defaultWidthVwNum = tableColumnData.length - deletColumnNum //减去这3列[teamLogo-teamName, arrowIcon, isExpand]
                console.debug('tableColumnData:', tableColumnData)
              }
            }

            let tableData = group.detail_list
              ? group.detail_list.map((rowData) => {
                  let currDataListRowNum = 0 //展开行有多高，取决于(上下半场)data.length个数
                  if (
                    rowData.row_detail &&
                    rowData.row_detail.data &&
                    rowData.row_detail.data.length > 0
                  ) {
                    rowData.isHasDetailData = true
                    if (rowData.row_detail.data.length > currDataListRowNum) {
                      currDataListRowNum = rowData.row_detail.data.length
                    }
                  } else {
                    rowData.isShowChild = false //就是全部展开，如果没有子内容，展开无用，所以变为false
                    rowData.isHasDetailData = false
                  }

                  rowData.arrowIcon = ''
                  if (this.isExpandAll) {
                    //是否全部展开
                    rowData.isShowChild = true
                  } else {
                    rowData.isShowChild = false
                  }

                  rowData.row_detail = rowData.row_detail
                    ? rowData.row_detail
                    : []

                  // rowHeightVw = 2.778 //第一行 行高
                  // childRowHeightVw = 1.944 //第一行的展开行，如果是表格的话，就是展示数据的那一行的行高（一般这个行数是不固定的）
                  // childRowHeightOtherVw = 0 //0.694是表格最下面的留白

                  // childRowBaseHeightVw = 3.332 + 1.944 //第一行展开行的基础高度（固定的高度）

                  let expandOtherList_head = []
                  if (
                    ['STK', 'SSK', 'SMT', 'SWM', 'ROW', 'RCB'].includes(
                      this.currSportsDetail.sportsId
                    )
                  ) {
                    this.tableColumnData.forEach((column, colIndex) => {
                      if (colIndex > 1) {
                        expandOtherList_head.push(column)
                      }
                    })
                    expandOtherList_head = expandOtherList_head.splice(
                      0,
                      expandOtherList_head.length - 2
                    ) //删除掉箭头占位的2列

                    if (
                      ['STK', 'SSK', 'ROW', 'RCB'].includes(
                        this.currSportsDetail.sportsId
                      ) &&
                      ['D-GP', 'T-GP'].includes(this.competitorType)
                    ) {
                      // 出场名单需要改变一下行数，一行
                      currDataListRowNum = Math.ceil(currDataListRowNum / 4) //每行4个运动员，8个运动员就是2行
                      console.debug(
                        'mode_15 currDataListRowNum:',
                        currDataListRowNum
                      )
                      rowHeightVw = 2.778 //第一行 行高
                      childRowHeightVw = 6.94 //第一行的展开行，如果是表格的话，就是展示数据的那一行的行高（一般这个行数是不固定的）
                      childRowHeightOtherVw = 0 //0.694是表格最下面的留白
                      childRowBaseHeightVw = 0 //第一行展开行的基础高度（固定的高度）
                    } else if (
                      this.competitorType === 'A' ||
                      (['ROW', 'RCB'].includes(
                        this.currSportsDetail.sportsId
                      ) &&
                        ['D', 'T'].includes(this.competitorType))
                    ) {
                      // 游泳只有A；赛艇A|D|T都走这里
                      rowHeightVw = 2.778 //第一行 行高
                      childRowHeightVw = 0 //第一行的展开行，如果是表格的话，就是展示数据的那一行的行高（一般这个行数是不固定的）
                      childRowHeightOtherVw = 0 //0.694是表格最下面的留白
                      childRowBaseHeightVw = 6.94 //第一行展开行的基础高度（固定的高度）
                    } else if (this.competitorType === 'T') {
                      // 处理 'STK', 'SSK' 为单行
                      if (
                        ['STK', 'SSK'].includes(this.currSportsDetail.sportsId)
                      ) {
                        currDataListRowNum = 1
                      }
                      // 游泳没有D,游泳只有T走这里
                      rowHeightVw = 2.778 //第一行 行高
                      childRowHeightVw = 6.94 //第一行的展开行，如果是表格的话，就是展示数据的那一行的行高（一般这个行数是不固定的）
                      childRowHeightOtherVw = 0 //0.694是表格最下面的留白
                      childRowBaseHeightVw = 0 //第一行展开行的基础高度（固定的高度）
                    }
                  }
                  rowData.isExpand = {
                    tabType: this.tabType,
                    renderMode: this.currSportsDetail.sportsId,
                    expandClassString: this.currModeObj.modeNameArr.join(' '),
                    rowHeightVw,
                    currHeightVw:
                      childRowBaseHeightVw +
                      currDataListRowNum * childRowHeightVw +
                      childRowHeightOtherVw,
                    list: rowData.row_detail,
                  }

                  return rowData
                })
              : []

            return {
              tabKey: group.group_code,
              tabName: group.group_name,
              tableData,
              tableColumnData,
              defaultWidthVwNum,
              tableTotal,
            }
          } else {
            return {
              tabKey: 'undefinedKey',
              tabName: '未定义',
              tableData: [],
              tableColumnData: [],
              defaultWidthVwNum: 0,
              tableTotal: 0,
            }
          }
        })

        if (this.groupTable.length > 0) {
          let actIndex = data.group_number ? data.group_number : 0 //分组的索引，从比赛列表第一次进入赛果读取比赛列表的索引，在赛果刷新读取赛果数据中的索引
          if (this.groupIndexStr && this.groupIndexStr - 0 >= 0) {
            actIndex = this.groupIndexStr
          }
          this.tabActiveKey = this.groupTable[actIndex].tabKey
          console.debug('actIndex:', actIndex)
        }
        // this.$refs.tableParentDom.scrollTo(0, 0)
        console.debug('this.groupTable:', this.groupTable)
      } else {
        console.debug('暂无数据')
        this.notDataHandler()
      }
      console.debug('mode_15:', this.groupTable)
    },
    notDataHandler() {
      this.groupTable = []
    },
  },
}
</script>

<style lang="scss" scoped>
.eventComp_mode_container {
  padding: 1.388vw 0;
  .tableScrollArea {
    position: relative;
    width: 100%;
  }
  .note_box {
    width: 100%;
    padding: 0.694vw 1.338vw 4.16vw;
    /* border-top: 1px solid var(--mixtmt_greyColor8); */
    .note_title {
      display: block;
      font-size: 1.11vw;
      color: var(--mixtmt_mainColor);
      line-height: 2.083vw;
      font-weight: bold;
    }
    .note_info {
      width: 100%;
      padding: 0 0.694vw 0 0;
      height: auto;
      display: flex;
      display: -webkit-flex;
      justify-content: flex-start;
      align-items: center;
      flex-wrap: wrap;
      .noteInfo_item {
        width: auto;
        min-width: 12.5%;
        text-align: left;
        font-size: 1.11vw;
        line-height: 2.5vw;
        color: var(--mixtmt_greyColor2);
        padding-left: 1.388vw;
        &:first-child {
          padding-left: 0.694vw;
        }
      }
    }
  }
}
</style>
<style lang="scss">
.mixtmt_pc {
  .eventComp_mode_container {
    .el-tabs__item:hover {
      cursor: pointer;
    }
  }
}
.eventComp_mode_container {
  .el-tabs--card > .el-tabs__header .el-tabs__nav {
    border-radius: 0.416vw 0.416vw 0 0;
    border-color: var(--mixtmt_table_headerBg);
    overflow: hidden;
  }
  .el-tabs__item {
    padding: 0 1.388vw;
    height: 2.788vw;
    line-height: 2.788vw;
    font-size: 1.11vw;
    min-width: 6.94vw;
    text-align: center;
  }
  .el-tabs--card > .el-tabs__header .el-tabs__item {
    border-left: 1px solid var(--mixtmt_table_headerBg);
  }
  .el-tabs--card > .el-tabs__header .el-tabs__item:first-child {
    border-left: none;
  }
  .el-tabs__header {
    margin: 0;
  }
  .el-tabs__item.is-active,
  .el-tabs__item.is-active:hover {
    background-color: var(--mixtmt_table_headerBg);
    color: var(--mixtmt_table_headerColor);
  }
  .el-tabs--card > .el-tabs__header .el-tabs__item.is-active {
    border-color: var(--mixtmt_table_headerBg);
  }
  .el-tabs__item:hover {
    color: var(--mixtmt_table_headerBg);
  }
  .el-tabs--bottom
    .el-tabs--left
    > .el-tabs__header
    .el-tabs__item:nth-child(2),
  .el-tabs--bottom
    .el-tabs--right
    > .el-tabs__header
    .el-tabs__item:nth-child(2),
  .el-tabs--bottom.el-tabs--border-card
    > .el-tabs__header
    .el-tabs__item:nth-child(2),
  .el-tabs--bottom.el-tabs--card > .el-tabs__header .el-tabs__item:nth-child(2),
  .el-tabs--top .el-tabs--left > .el-tabs__header .el-tabs__item:nth-child(2),
  .el-tabs--top .el-tabs--right > .el-tabs__header .el-tabs__item:nth-child(2),
  .el-tabs--top.el-tabs--border-card
    > .el-tabs__header
    .el-tabs__item:nth-child(2),
  .el-tabs--top.el-tabs--card > .el-tabs__header .el-tabs__item:nth-child(2) {
    padding-left: 1.388vw;
  }
  .el-cascader-menu:last-child .el-cascader-node,
  .el-tabs--bottom .el-tabs--left > .el-tabs__header .el-tabs__item:last-child,
  .el-tabs--bottom .el-tabs--right > .el-tabs__header .el-tabs__item:last-child,
  .el-tabs--bottom.el-tabs--border-card
    > .el-tabs__header
    .el-tabs__item:last-child,
  .el-tabs--bottom.el-tabs--card > .el-tabs__header .el-tabs__item:last-child,
  .el-tabs--top .el-tabs--left > .el-tabs__header .el-tabs__item:last-child,
  .el-tabs--top .el-tabs--right > .el-tabs__header .el-tabs__item:last-child,
  .el-tabs--top.el-tabs--border-card
    > .el-tabs__header
    .el-tabs__item:last-child,
  .el-tabs--top.el-tabs--card > .el-tabs__header .el-tabs__item:last-child {
    padding-right: 1.388vw;
  }
}
</style>
